export const PARTNERSHIPS = 'partnerships';
